import { parseCommentSegments } from "@nova/schemas"
import { useFullnameForUserId } from "features/data-management/users/storage"
import { UserProfileModalTrigger } from "features/users/UserProfileModal"

const MentionChip = ({ userId }: { userId: string }) => {
    const { fullName } = useFullnameForUserId(userId)
    return (
        <UserProfileModalTrigger
            userId={userId}
            className="inline text-blue-400 font-medium hover:underline"
        >
            @{fullName ?? "user"}
        </UserProfileModalTrigger>
    )
}

export const CommentText = ({ text, className }: { text: string; className?: string }) => (
    <div className={className}>
        {parseCommentSegments(text).map((segment, index) => {
            if (segment.type === "mention") {
                return <MentionChip key={index} userId={segment.userId} />
            }
            if (segment.type === "link") {
                return (
                    <a
                        key={index}
                        href={segment.url}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="text-blue-400 underline"
                    >
                        {segment.label}
                    </a>
                )
            }
            return <span key={index}>{segment.value}</span>
        })}
    </div>
)
